import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
declare var _: any;

@Component({
  selector: 'checkbox-or-radio',
  templateUrl: './checkbox-or-radio.component.html',
  styleUrls: ['./checkbox-or-radio.component.less']
})
export class CheckboxOrRadioComponent implements OnInit {
  @Input() question: any;
  @Output() answered: EventEmitter<any> = new EventEmitter();
  @Output() answerCleared: EventEmitter<any> = new EventEmitter();
  @Output() modified: EventEmitter<any> = new EventEmitter();
  hasAnswer: boolean = false;
  naAnswered: boolean = false;

  ngOnInit() {
    this.hasAnswer = _.some(this.question.rows, (row: any) => row.value);

    if (this.question.qType === 'checkbox') {
      // check if checkbox has answer of n/a
      this.naAnswered = _.some(this.question.rows, (row: any) => {
        return row.value && row.type === 'na';
      });
    }

    if (this.naAnswered)
      this.clearAllNonNa();
  }

  setValue(answer) {
    if (this.question.qType === 'radio') {
      let alreadySet: boolean = false;
      _.each(this.question.rows, (row: any) => {
        // avoid emit when double clicking
        if (row._id === answer._id && row.value === true) {
          alreadySet = true;
          return;
        }
        row.value = false;
      });

      if (alreadySet) return;

      answer.value = true;

      if (!this.hasAnswer) {
        this.answered.emit(null);
        this.hasAnswer = true;
      }
    } else {
      // checkbox
      let hasAnswerNow: boolean;

      answer.value = !answer.value;

      hasAnswerNow = _.some(this.question.rows, (row: any) => row.value);

      if (answer.type === 'na' && answer.value) {
        this.clearAllNonNa();
        this.naAnswered = true;
      } else if (answer.type === 'na' && !answer.value) {
        this.naAnswered = false;
      }

      if (hasAnswerNow && !this.hasAnswer) {
        this.hasAnswer = true;
        this.answered.emit(null);
      }

      if (!hasAnswerNow && this.hasAnswer) {
        this.hasAnswer = false;
        this.answerCleared.emit(null);
      }
    }

    this.modified.emit(null);
  }

  clearAllNonNa() {
    _.each(this.question.rows, (row: any) => {
      if (row.value && row.type !== 'na')
        row.value = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/survey/checkbox-or-radio/checkbox-or-radio.component.ts